import { create } from "zustand";

interface AuditLimitModalState {
  isOpen: boolean;
  maxAudits?: number;
  open: (maxAudits?: number) => void;
  close: () => void;
}

export const useAuditLimitModal = create<AuditLimitModalState>((set) => ({
  isOpen: false,
  maxAudits: undefined,
  open: (maxAudits) => set({ isOpen: true, maxAudits }),
  close: () => set({ isOpen: false, maxAudits: undefined }),
}));

/**
 * Check if an error is an AUDIT_LIMIT_REACHED error and open the modal if so.
 * Works with ApiError from useApiMutation (error.details.code) and
 * raw thrown errors (error.code or error.details.code).
 * Returns true if the error was handled, false otherwise.
 */
export function handleAuditLimitError(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;

  const err = error as Record<string, unknown>;

  // Check error.details.code (ApiError from makeHandler Result pattern)
  const details = err.details as Record<string, unknown> | undefined;
  if (details?.code === "AUDIT_LIMIT_REACHED") {
    const maxAudits =
      typeof details.maxAudits === "number" ? details.maxAudits : undefined;
    useAuditLimitModal.getState().open(maxAudits);
    return true;
  }

  return false;
}
